module.exports = __webpack_public_path__ + "img/20180815_151538_165.05a30826.jpg";